import Payer from '@/services/payer'
import Mailer from '@/services/mailer'
import Documents from '@/services/documents'
import User from '@/services/user'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'
import Btg from '@/services/btg'

const sendWelcomeMail = async (context, id) => {
  return new Promise((resolve, reject) => {
    Mailer.payerSendWelcomeEmail(id)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Payer.fetch()
      .then((response) => {
        commit('SET_LIST', response.data.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const find = async (context, id) => {
  return new Promise((resolve, reject) => {
    Payer.get(id)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const findCommit = async ({ commit }, id) => {
  return new Promise(async (resolve, reject) => {
    Payer.get(id)
      .then((response) => {
        commit('SET_PAYER', response.data)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const fetchCurrentPayer = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Payer.getCurrent()
      .then((response) => {
        commit('SET_CURRENT', response.data)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const findByToken = async (context, token) => {
  return new Promise(async (resolve, reject) => {
    User.findByToken(token).then((response) => {
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const saveByToken = (context, obj) => {
  const { token, user } = obj
  return new Promise(async (resolve, reject) => {
    User.saveByToken(token, user).then((response) => {
      resolve(response.data)
    })
    .catch((error) => {
      reject(error)
    })
  })
}

const save = async ({ commit }, obj) => {
  return new Promise(async (resolve, reject) => {
    const { verb, dataPayer } = obj
    const method = verb === 'put' ? 'update' : 'save'

    Payer[method](dataPayer)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        commit('SET_ERRORS', error.response.data)
        reject(error)
      })
  })
}

const sendDocs = (context, data) => {
  return new Promise(async (resolve, reject) => {
    Documents.sendPayerDocs(data)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        bus.$emit('display-alert', {
          type: 'error',
          message: formatErrors(error.response.data)
        })
        reject(error)
      })
  })
}

const fetchByList = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Payer.byCampaign()
      .then((response) => {
        commit('SET_LIST_TO_CAMPAIGN', response.data)
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

const fetchFeeTerm = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Btg.feePerTerm(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const feeTermDownload = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Btg.feePerTermDowload(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const feeTermUpload = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Btg.feePerTermUpload(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const findAssignorsByPayer = async (context, id) => {
  return new Promise((resolve, reject) => {
    Payer.getAssignors(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchEmailTemplates = async (context) => {
  return new Promise((resolve, reject) => {
    Mailer.templates().then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

const resetStatePayer = ({ commit }) => {
  commit('RESET_PAYER')
}

const resetStateErrors = ({ commit }) => {
  commit('RESET_ERRORS')
}

const updateValues = (context, obj) => {
  context.commit('UPDATE_VALUES', obj)
}

export default {
  fetch,
  fetchCurrentPayer,
  fetchEmailTemplates,
  find,
  findCommit,
  findByToken,
  saveByToken,
  sendWelcomeMail,
  save,
  sendDocs,
  resetStatePayer,
  resetStateErrors,
  updateValues,
  fetchByList,
  findAssignorsByPayer,
  fetchFeeTerm,
  feeTermUpload,
  feeTermDownload
}



// WEBPACK FOOTER //
// ./src/features/payers/store/actions.js